import React from 'react';
import classNames from 'classnames';
import Config from '../config';
import CONSTANTS from '../config/constants';
import _ from 'lodash';
import moment from "moment";

export function classNamesPrefixed(classes, prefix = true) {
  const prefixedClasses = {};

  _.each(classes, (trueOrFalse, className) => {
    if (prefix) {
      prefixedClasses[Config.prefix + className] = trueOrFalse;
    } else {
      prefixedClasses[className] = trueOrFalse;
    }
  });

  return classNames(prefixedClasses);
}

export function GenerateRecursiveChildsWithParams(data, parentWorkspaceId, onClick, selected, search = false, blockType, level = 1) {
  const results = [];

  data.forEach((item) => {
    let itemSelected = false;
    let disabled = false;
    let hidden = false;
    let match = false;

    if (_.isArray(selected)) {
      itemSelected = _.find(selected, {contentId: item.id});
    } else {
      itemSelected = selected === item.id;
    }

    if (search) {
      match = _.includes(item.title.toLowerCase(), search.toLowerCase());

      if (match) {
        disabled = false;
      } else {
        disabled = true;
      }
    }

    if (search) {
      if (disabled) {
        if (item.children.length === 0) {
          hidden = true;
        }
      }
    }

    results.push(
     <li key={item.id}>
       <div onClick={(e) => {
         e.preventDefault();

         onClick(parentWorkspaceId, item.id, item.title);
       }}
            className={classNamesPrefixed({
              'item': true,
              'match': match,
              'selected': itemSelected,
              'disabled': disabled,
              'hidden': hidden,
              ['level-' + level]: true
            })}
       >
         {item.title} ({item.contentDefinitionKey})
       </div>
       <ul>
         {GenerateRecursiveChildsWithParams(item.children, parentWorkspaceId, onClick, selected, search, blockType, level + 1)}
       </ul>
     </li>
    );
  });

  return results;
}

export function GetFlatArrayFromRecursive(data, level = 1, results = []) {
  data.forEach((content) => {
    results.push(content);

    if (content.children && content.children.length > 0) {
      GetFlatArrayFromRecursive(content.children, level + 1, results);
    }
  });

  return results;
}

export function GetArrayFromRecursive(data, level = 1, results = []) {
  let prefix = '';

  for (let i = 0; i < level; i++) {
    prefix += '-';
  }

  data.forEach((content) => {
    results.push({
      id: content.id,
      title: prefix + ' ' + content.title
    });

    if (content.children && content.children.length > 0) {
      GetArrayFromRecursive(content.children, level + 1, results);
    }
  });

  return results;
}

export function ProcessRelatedContents(fields, results = []) {
  if (fields) {
    _.each(fields, (field) => {
      results[field.id] = ProcessContentFields(field.contentFields);

      if (field.relatedContents && field.relatedContents.length) {
        ProcessRelatedContents(field.relatedContents, results);
      }
    });
  }

  return results;
}

export function ProcessContentFields(fields) {
  const values = {};

  if (fields) {
    fields.forEach((field) => {
      try {
        values[field.fieldDefinitionKey] = JSON.parse(field.data);
      } catch (e) {
        values[field.fieldDefinitionKey] = field.data;
      }
    });
  }

  return values;
}

export function GetFileExtension(filename) {
  if (filename) {
    return filename.split(".").pop();
  }
}

export function GetFileType(fileName) {
  switch (GetFileExtension(fileName).toLowerCase()) {
    case "jpg":
    case "png":
    case "gif":
    case "jpeg":
    case "svg":
      return {
        id: "images",
        title: "Images"
      };
    case "pdf":
    case "doc":
    case "docx":
      return {
        id: "documents",
        title: "Documents"
      };
    case "txt":
      return {
        id: "txt",
        title: "Text files"
      };
    case "zip":
    case "rar":
    case "gzip":
    case "tar":
      return {
        id: "archives",
        title: "Archives"
      };
    case "xml":
      return {
        id: "xml",
        title: "Xml"
      };
    default:
      return {
        id: "unknown-file-type",
        title: "Unknown file type"
      };
  }
}

export function normalizeItems(items, parentId = null) {
  const result = [];

  for (let element of items) {
    const item = {
      id: element.id,
      parentId: parentId,
      title: element.title,
      children: []
    };

    if (element.children.length > 0) {
      item.children = normalizeItems(element.children, element.id)
    }

    result.push(item)
  }

  return result
}

export function findItem(items, id) {
  let result = null;

  for (let element of items) {
    if (element.id === id) {
      result = {
        id: element.id,
        parentId: element.parentId,
        title: element.title
      };

      break
    }

    if (element.children.length > 0) {
      result = findItem(element.children, id);

      if (result) {
        break;
      }
    }
  }

  return result
}

export function getPageUrl(id) {
  return Config.frontURL + '#/page/' + id;
}


export function isLogged() {
  let token = Config.getToken() ? true : false;
  let loggedInUser = Config.getUser();
  return (token && loggedInUser);
}

export function isAdmin() {
  return isLogged();
}

export function getPageTitle(frontendTheme) {

  switch (frontendTheme) {
    case "awave":
      return "Demo page";

    case "electrolux-public":
      return "Electrolux Functional Areas";

    default:
      return "Electrolux Job Architecture";
  }

}

export function makeid() {
  var text = "";
  var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  for (var i = 0; i < 5; i++)
    text += possible.charAt(Math.floor(Math.random() * possible.length));

  return text;
}

export function getRoleIdFromRoleName(roleName) {

  let roleId = 0;
  switch (roleName) {

    case "LineManager":
      roleId = 2;
      break;

    case "Admin":
      roleId = 3;
      break;

    case "Employee":
      roleId = 1;
      break;

    case "Hrbp":
      roleId = 4;
      break;

    default:
      roleId = 0;
      break;
  }

  return roleId;
}

export function isLocalHost() {
  //10.0.2.2 - calls from virtual box
  return (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1" || window.location.hostname === "10.0.2.2")
}

export function isBackend() {
  const renderer = document.getElementById('application').getAttribute('data-renderer');
  if (renderer === "backend") {
    return true;
  }
  return false;
}

export function itemName(item) {
  if (item.firstName && item.lastName) {
    return item.firstName + " " + item.lastName;
  }

  return item.name;
}

export function itemDescription(item, hideAddress = false) {

  let description = [];

  if (isEmployee()) {
    description.push("Electrolux Employee")
  }

  if (isPartner() && item.ispCompany) {
    description.push(item.ispCompany)
  }

  if (isCustomer() && item.store) {
    description.push(item.store)
  }

  if (item.position) {
    description.push(item.position)
  }

  if (item.street && !hideAddress) {
    description.push(item.street)
  }
  if (item.zipCode && !hideAddress) {
    description.push(item.zipCode)
  }

  if (item.city) {
    description.push(item.city)
  }

  if (isEmployee() && item.region) {
    description.push(item.region)
  }

  if (item.location) {
    description.push(item.location)
  }

  // if (item.country) {
  //     description.push(item.country)
  // }

  // if (item.name) {
  //     description.push(item.name)
  // }

  if (description.length > 1) {
    return description.join(", ");
  } else {
    return description.join("");
  }

}

export function isActiveMenu(currentPath, path, startsWith = false, pageTitle) {
  let isActive = false;

  if (startsWith) {
    isActive = currentPath.startsWith(startsWith);
  } else {
    isActive = currentPath === path;
  }

  if (isActive) {
    if (pageTitle && pageTitle !== document.title) {
      document.title = pageTitle;
    }
  }
  return isActive;
}

export function fixUrl(url) {
  return url;
}

export function getRoleId(name) {

  switch (name) {
    case "Customer":
      return CONSTANTS.ROLES.CUSTOMER.ID;
    case "Employee":
      return CONSTANTS.ROLES.EMPLOYEE.ID;
    case "Partner":
      return CONSTANTS.ROLES.PARTNER.ID;
    default:
      return null;
  }
}

export function isEmployee() {
  const loggedInUser = Config.getUser();
  if (loggedInUser && loggedInUser.Role && loggedInUser.Role === CONSTANTS.ROLES.EMPLOYEE.NAME) {
    return true
  }
  return false;
}

export function isPartner() {
  const loggedInUser = Config.getUser();
  if (loggedInUser && loggedInUser.Role && loggedInUser.Role === CONSTANTS.ROLES.PARTNER.NAME) {
    return true
  }
  return false;
}

export function isCustomer() {
  const loggedInUser = Config.getUser();
  if (loggedInUser && loggedInUser.Role && loggedInUser.Role === CONSTANTS.ROLES.CUSTOMER.NAME) {
    return true;
  }
  return false;
}

export function getLeaderBoardPageSize() {
  return CONSTANTS.USER_LIST_PAGE_SIZE;
}

export function getDefaultFilters(groupBy) {

  let filter = {
    groupBy: 0,
    position: [],
    store: [],
    time: null,
    cluster: [],
    location: []
  };
  let loggedInUser = Config.getUser();
  if (groupBy !== null) {

    filter = {
      ...filter,
      groupBy: groupBy
    };

    switch (parseInt(groupBy, 10)) {
      case CONSTANTS.GROUPBY.ME:
        if ((isEmployee() || isPartner())) {
          filter = {
            ...filter,
            location: parseInt(loggedInUser.Location, 10) ? [parseInt(loggedInUser.Location, 10)] : null,
            position: isEmployee() && parseInt(loggedInUser.Position, 10) ? [parseInt(loggedInUser.Position, 10)] : null
          }
        }
        break;

      case CONSTANTS.GROUPBY.POSITION:
        if (isEmployee()) {
          filter = {
            ...filter,
            location: [parseInt(loggedInUser.Location, 10)]
          }
        }
        break;

      case CONSTANTS.GROUPBY.COUNTRY:
        if (isEmployee()) {
          filter = {
            ...filter,
            location: [parseInt(loggedInUser.Location, 10), -1]
          }
        }
        break;

      default:
        break;
    }
  }
  return filter;
}


export function getTimeOptions() {
  return [
    {
      id: CONSTANTS.TIME.ALLTIME,
      name: "All time"
    },
    {
      id: CONSTANTS.TIME.THISYEAR,
      name: "This year"
    },
    {
      id: CONSTANTS.TIME.THISQUARTER,
      name: "This quarter"
    },
    {
      id: CONSTANTS.TIME.LAST6MONTH,
      name: "This half year"
    },
    {
      id: CONSTANTS.TIME.THISMONTH,
      name: "This month"
    },
    {
      id: CONSTANTS.TIME.THISWEEK,
      name: "This week"
    },
    {
      id: CONSTANTS.TIME.CUSTOM,
      name: "Select custom time frame"
    },
    // {
    //     id: CONSTANTS.TIME.CUSTOM,
    //     name: "Custom"
    // }
  ];
}

export function getMenu() {
  return [
    {
      id: "store",
      title: "Store",
      enabled: isCustomer(),
    },
    {
      id: "position",
      title: "Position",
      enabled: true,
    },
    // {
    //     id: "cluster",
    //     title: isEmployee() ? "Cluster" : "Location",
    //     enabled: isPartner() ? false : true,
    // },
    // {
    //     id: "location",
    //     title: "Location",
    //     enabled: false,
    // },
    {
      id: "cluster",
      title: isEmployee() ? "Cluster" : "Location",
      enabled: isPartner() || isCustomer() ? false : true,
    },
    {
      id: "location",
      title: "Location",
      enabled: false,
    },
    {
      id: "time",
      title: "Time",
      enabled: true,
    }
  ];
}


export function isSectionDisabled(section, groupBy) {
  let isDisabled = false;
  switch (parseInt(groupBy, 10)) {
    case 2:
      //city
      if (section === "store") {
        isDisabled = true;
      }
      break;
    case 3:
      //country
      // if (section === "location") {
      //     isDisabled = true;
      // }
      break;
    case 4:
      //position
      // if (section === "position") {
      //     isDisabled = true;
      // }
      break;
    default:
      break;
  }

  return isDisabled;
}

export function getIcon(sectionName) {
  let icon = null;

  switch (sectionName) {
    case "position":
      icon = "user-tie";
      break;
    case "location":
      icon = "map-marker-alt";
      break;
    case "cluster":
      icon = "map-marked-alt";
      break;
    case "store":
      icon = "home";
      break;
    case "time":
      icon = "time";
      break;
    default:
      break;
  }
  return icon;
}

export function getGroupByOptions() {
  return [
    {
      id: CONSTANTS.GROUPBY.ME,
      title: "my",
      enabled: true,
    },
    {
      id: CONSTANTS.GROUPBY.STORE,
      title: "my store's",
      enabled: !isEmployee() && !isPartner() && isCustomer(),
    },
    {
      id: CONSTANTS.GROUPBY.CITY,
      title: "my city's",
      enabled: false, //!isEmployee() && !isCustomer() && !isPartner(),
    },
    {
      id: CONSTANTS.GROUPBY.COUNTRY,
      title: "my country's",
      enabled: !isPartner() && !isCustomer(),
    },
    {
      id: CONSTANTS.GROUPBY.POSITION,
      title: "my position's",
      enabled: true,
    },
  ]
}

export function reformatFilterValues(postData) {


  let pd = {};
  let locationAll = true;
  let positionAll = true;
  let storeAll = true;
  let clusterAll = true;

  if (postData.location && postData.location.length > 0) {
    locationAll = postData.location.indexOf(-1) > -1 ? true : false;
  }
  if (postData.position && postData.position.length > 0) {
    positionAll = postData.position.indexOf(-1) > -1 ? true : false;
  }
  if (postData.store && postData.store.length > 0) {
    storeAll = postData.store.indexOf(-1) > -1 ? true : false;
  }
  if (postData.cluster && postData.cluster.length > 0) {
    clusterAll = postData.cluster.indexOf(-1) > -1 ? true : false;
  }

  if (postData) {
    pd = {
      ...postData,
      LocationIds: (locationAll ? [] : postData.location),
      PositionIds: (positionAll ? [] : postData.position),
      StoreIds: (storeAll ? [] : postData.store),
      ClusterIds: (clusterAll ? [] : postData.cluster),
      GroupBy: postData.groupBy,
      DateFilter: ((postData.time && postData.time.timeSelect) ? postData.time.timeSelect.id : 0)
    };

    if (postData.time && postData.time.timeSelect && postData.time.timeSelect.id === CONSTANTS.TIME.CUSTOM) {
      if (postData.time.customTimeDateFrom) {
        pd.DateFrom = moment(postData.time.customTimeDateFrom).format("YYYY-MM-DD") + "T00:00:00";
      }

      if (postData.time.customTimeDateTo) {
        pd.DateTo = moment(postData.time.customTimeDateTo).format("YYYY-MM-DD") + "T00:00:00";
      }
    }

    delete pd.location;
    delete pd.position;
    delete pd.store;
    delete pd.groupBy;
    delete pd.time;
    delete pd.cluster;
  }

  return pd;
}

export function setFormDefaultValues(sectionName, checkBoxItems, selectItems, groupBy, change) {
  const loggedInUser = Config.getUser();
  const userLocationId = parseInt(loggedInUser.Location, 10);
  let filter = getDefaultFilters(groupBy);

  if (!filter[sectionName] || filter[sectionName].length === 0) {
    change('store.storeItems.store_default_-1', false);
    if (sectionName !== "store" && sectionName !== "cluster") {
      checkAllOptions(sectionName, checkBoxItems, change);
    }
  } else {
    for (let x in filter[sectionName]) {
      let itemId = parseInt(filter[sectionName][x], 10);
      if (itemId > 0) {
        change('location.locationItems.location_default_' + itemId, true);
        change('location.locationItems.location_' + itemId, true);
        change('location.locationItems.location_default_-1', false);
      } else {
        checkAllOptions(sectionName, checkBoxItems, change);
      }
    }
  }

  if (sectionName === "position" && loggedInUser.Position && isEmployee()) {
    change('position.positionItems.position_default_' + loggedInUser.Position, true);
  }

  if (sectionName === "cluster") {
    const clustersFlat = flatClusters(checkBoxItems);
    for (const x of clustersFlat) {
      if (x.originalId === userLocationId) {
        change('cluster.clusterItems.cluster_' + x.id, true);
        if (x.parentId) {
          for (const y of clustersFlat) {
            if (x.parentId === parseInt(y.id, 10)) {
              change('cluster.clusterItems.cluster_' + x.parentId, true);
              if (y.parentId) {
                for (const z of clustersFlat) {
                  if (y.parentId === parseInt(z.id, 10)) {
                    change('cluster.clusterItems.cluster_' + y.parentId, true);
                    if (z.parentId) {
                      for (const n of clustersFlat) {
                        if (z.parentId === parseInt(n.id, 10)) {
                          change('cluster.clusterItems.cluster_' + z.parentId, true);
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  if (sectionName === "store") {
    let c = selectItems ? selectItems : [];
    const userCountry = ((userLocationId && c) ? c.filter(item => item.id === userLocationId) : null);
    let defaultCountry = userCountry.length > 0 ? {
      value: userCountry[0].id,
      label: userCountry[0].name,
      id: userCountry[0].id
    } : null;

    if (isCustomer() && defaultCountry) {
      change('store.storeSelect', defaultCountry);
    }
  }

  if (sectionName === "time") {
    change('time.timeSelect', {value: 0, label: "All time", id: 0});
  }
}

export function checkAllOptions(filterName, items, change) {
  change(filterName + '.' + filterName + 'Items.' + filterName + '_default_-1', true);
  for (let x in items) {
    let children = items[x].childrenLocations ? items[x].childrenLocations : items[x].childrenPositions;

    change(filterName + '.' + filterName + 'Items.' + filterName + '_' + items[x].id, true);
    if (children && children.length > 0) {
      checkAllOptions(filterName, children, change);
    }
  }
  let df = getDefaultCheckboxes(filterName, items);
  for (let x in df) {
    if (df[x].id !== -1) {
      change(filterName + '.' + filterName + 'Items.' + filterName + '_default_' + df[x].id, false);
    }
  }
}

export function findChildren(selectedValue, childrenKey, item) {
  if (parseInt(item.id, 10) === parseInt(selectedValue, 10)) {
    return item;
  }
  if (item && item[childrenKey]) {
    for (const x of item[childrenKey]) {
      const item =  findChildren(selectedValue, childrenKey, x);
      if (item){
        return item;
      }
    }
  }
  return null;
}

export function getDefaultCheckboxes(section, checkBoxItems, groupBy) {
  const loggedInUser = Config.getUser();
  let filtersToReturn = [];

  switch (section) {

    case "store":
      filtersToReturn.push({
        id: -1,
        name: "Select all"
      });
      break;

    case "position":
      const positions = checkBoxItems;
      filtersToReturn.push({
        id: -1,
        name: "All Positions"
      });

      if (positions && !isCustomer()) {
        for (const x of positions) {

          const foundChild = findChildren(loggedInUser.Position, 'childrenPositions', x);
          if (foundChild) {
            filtersToReturn.push({
              id: foundChild.id,
              name: foundChild.name,
              icon: true,
              disabled: groupBy === CONSTANTS.GROUPBY.POSITION,
              forceChecked: groupBy === CONSTANTS.GROUPBY.POSITION
            });
          }
        }
      }
      break;

    case "location":
      const countries = checkBoxItems;
      filtersToReturn.push({
        id: -1,
        name: "All Locations"
      });

      if (countries) {
        for (let x in countries) {
          if (parseInt(countries[x].id, 10) === parseInt(loggedInUser.Location, 10)) {
            filtersToReturn.push({
              id: countries[x].id,
              name: countries[x].name,
              icon: true,
              disabled: groupBy === CONSTANTS.GROUPBY.COUNTRY,
              forceChecked: groupBy === CONSTANTS.GROUPBY.COUNTRY
            });
          }
        }
      }
      break;

    case "cluster":
      const clusters = checkBoxItems;
      filtersToReturn.push({
        id: -1,
        name: isEmployee() ? "All clusters" : "All locations"
      });

      if (clusters) {
        for (let x in clusters) {
          if (parseInt(clusters[x].id, 10) === parseInt(loggedInUser.RegionId, 10)) {
            filtersToReturn.push({
              id: clusters[x].id,
              name: clusters[x].name,
              icon: true
            });
          }
        }
      }

      break;
    default:
      break;
  }
  return filtersToReturn;
}

export function flatClusters(clusters, pid) {
  let returnData = [];
  let childData = [];
  for (let x in clusters) {
    clusters[x].pId = pid;
    returnData.push(clusters[x]);
    if (clusters[x].childrenLocations && clusters[x].childrenLocations.length > 0) {
      childData = flatClusters(clusters[x].childrenLocations, clusters[x].ouId);
      for (let y in childData) {
        returnData.push(childData[y]);
      }
    }
  }
  return returnData;
}

export function flatPositions(positions, pid) {
  let returnData = [];
  let childData = [];
  for (let x in positions) {
    positions[x].pId = pid;
    returnData.push(positions[x]);
    if (positions[x].childrenPositions && positions[x].childrenPositions.length > 0) {
      childData = flatPositions(positions[x].childrenPositions, positions[x].ouId);
      for (let y in childData) {
        returnData.push(childData[y]);
      }
    }
  }
  return returnData;
}

export function idToOuId(clusters) {
  let clustersToReturn = [];
  for (let x in clusters) {
    clusters[x].originalId = clusters[x].id;
    clusters[x].id = clusters[x].ouId;
    if (clusters[x].childrenLocations && clusters[x].childrenLocations.length) {
      clusters[x].childrenLocations = idToOuId(clusters[x].childrenLocations);
    }
    clustersToReturn.push(clusters[x]);
  }

  return clustersToReturn;
}


export function isPilot() {
  return (Config.api.endpoint.indexOf("pilot") > -1) ? true : false;
}


export function getLocationId(countryName) {
  return isPilot() || isLocalHost() ? CONSTANTS.LOCATION[countryName].PILOT : CONSTANTS.LOCATION[countryName].LIVE;
}



// WEBPACK FOOTER //
// ./src/helpers/Helpers.js